import {
  CalendarChangeDeliveryDateDisabledIcon,
  CalendarChangeDeliveryDateIcon,
  DumpIcon,
  FoldedPaperDisabledIcon,
  FoldedPaperIcon,
} from "@components/Icons";
import StatusTag from "@components/StatusTagGeneric/StatusTagGeneric";
import {
  IconButton,
  TableCell,
  TableRow,
  Tooltip,
  Fade,
  CircularProgress,
  Collapse,
} from "@material-ui/core";
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";
import { IQueryOrderDataDTO } from "@modules/orders/dtos/IQueryOrderDataDTO";
import { DownloadType } from "@modules/orders/models/DownloadNfeQuery";
import DetailsOrdersStatus, {
  statusType,
} from "@pages/User/MyOrders/DetailsOrdersStatus";
import { format } from "date-fns";
import React from "react";
import { usePixByOrder } from "./hook/usePixByOrder";
import { financialStatusAcronym } from "./models/ENUM_MY_ORDERS";
import { useStylesTableOrders } from "./TableOrders";
import {
  getCreatorDisplayName,
  getFinancialStatus,
  getFinancialStatusPTBR,
  isBlockCalendarDelivery,
} from "./utilsOrders/utilsMyOrders";
import PixMobileModel from "./Sections/PixMobileModel";
import PixPaymentPanel from "./Sections/PixPaymentPanel";
import RowDetailMenu from "./Sections/RowDetailMenu";
import { formatCurrency, formatCurrency4DecimalsPlace } from "@utils/index";

interface ITableRowDataProps {
  ele: IQueryOrderDataDTO;
  index: number;
  isMobile: boolean;
  rowLoading: boolean[];
  downloadByLineTable: (
    type: DownloadType,
    nfKey?: string,
    rowIndex?: number
  ) => Promise<void>;
  getPaymentType: (paycond: number) => string;
  select: (rowId: string, type: "orders" | "pix") => void;
  isOpen: (rowId: string, type: "orders" | "pix") => boolean;
  featureFlagDeliveryDate: boolean;
  handleOpenDeliveryCalendar: () => void;
  setFreightTypeByLine: React.Dispatch<React.SetStateAction<string>>;
  setNumberOrderByLine: React.Dispatch<React.SetStateAction<string>>;
  setDeliveryDate: React.Dispatch<React.SetStateAction<Date | null>>;
  setOrderToCancel: React.Dispatch<
    React.SetStateAction<IQueryOrderDataDTO | null>
  >;
  setOpenModal: React.Dispatch<React.SetStateAction<boolean>>;
  setIndexClicked: React.Dispatch<React.SetStateAction<number>>;
  setOpenDialog: React.Dispatch<React.SetStateAction<boolean>>;
}

const TableRowData: React.FC<ITableRowDataProps> = (props) => {
  const {
    ele,
    index,
    isMobile,
    rowLoading,
    downloadByLineTable,
    getPaymentType,
    select,
    isOpen,
    featureFlagDeliveryDate,
    handleOpenDeliveryCalendar,
    setFreightTypeByLine,
    setNumberOrderByLine,
    setDeliveryDate,
    setOrderToCancel,
    setOpenModal,
    setIndexClicked,
    setOpenDialog,
  } = props;

  const classes = useStylesTableOrders();

  const isVista = ele.payCond === 0;
  const shouldFetchPix =
    isVista && (isMobile || isOpen(ele.numberOrder, "pix"));

  const { loading, payloads, error } = usePixByOrder(
    shouldFetchPix ? ele.numberOrder : null
  );

  return (
    <Fade key={ele.numberOrder} in={true} timeout={1000}>
      <>
        <TableRow>
          {!isMobile && (
            <TableCell align="center" className={classes.TableCellFromData}>
              <Tooltip title="Baixar NF">
                <IconButton
                  color="primary"
                  disabled={
                    ele.statusAtem !== financialStatusAcronym.FT_FATURADO
                      ? true
                      : false
                  }
                  onClick={() => {
                    downloadByLineTable("pdf", ele?.nfKey, index);
                  }}
                >
                  {rowLoading[index] ? (
                    <CircularProgress
                      color="primary"
                      style={{ height: "2.5rem", width: "2.5rem" }}
                    />
                  ) : (
                    <>
                      {ele.statusAtem !== financialStatusAcronym.FT_FATURADO ? (
                        <FoldedPaperDisabledIcon />
                      ) : (
                        <FoldedPaperIcon />
                      )}
                    </>
                  )}
                </IconButton>
              </Tooltip>
            </TableCell>
          )}

          <TableCell
            align={isMobile ? "left" : "center"}
            style={{
              fontSize: isMobile ? "1.3rem" : "",
              padding: isMobile ? "15px 21px" : "",
            }}
            className={classes.TableCellFromData}
          >
            {ele.numberOrder}
          </TableCell>

          <TableCell
            align={isMobile ? "left" : "center"}
            className={classes.TableCellFromData}
            style={{
              padding: isMobile ? "0px 16px" : "",
              fontSize: isMobile ? "1.3rem" : "",
            }}
          >
            {((ele.deliveryDate as unknown) as string) !== "0000-00-00" &&
              format(new Date(ele.deliveryDate), "dd/MM/yyyy")}
          </TableCell>

          {isMobile && (
            <>
              <TableCell
                align="center"
                style={{
                  border: "none",
                  padding: "16px 0px",
                }}
                className={classes.TableCellFromData}
              >
                <IconButton
                  size={"small"}
                  onClick={() => {
                    setIndexClicked(index);
                    setOpenDialog(true);
                  }}
                >
                  <ArrowForwardIosIcon color="primary" fontSize="small" />
                </IconButton>
              </TableCell>

              <TableCell align="center" className={classes.TableCellFromData}>
                <PixMobileModel
                  razaoSocial={ele.companyName}
                  produto={ele.productName}
                  valorTotal={ele.totalPrice}
                  payCond={ele.payCond}
                  payloads={payloads}
                  loading={loading}
                  error={error}
                />
              </TableCell>

              <TableCell align="center" className={classes.TableCellFromData}>
                <Tooltip title="Excluir Pedido">
                  <IconButton
                    size={"small"}
                    color="primary"
                    onClick={() => {
                      setOrderToCancel(ele);
                      setOpenModal(true);
                    }}
                  >
                    <DumpIcon fontSize="small" />
                  </IconButton>
                </Tooltip>
              </TableCell>
            </>
          )}

          {!isMobile && (
            <>
              <TableCell align="center" className={classes.TableCellFromData}>
                {ele.filial}
              </TableCell>
              <TableCell
                align="left"
                className={classes.TableCellFromData}
                style={{ whiteSpace: "nowrap" }}
              >
                {ele.companyName && ele.companyName}
              </TableCell>
              <TableCell
                align="left"
                className={classes.TableCellFromData}
                style={{ whiteSpace: "nowrap" }}
              >
                {`${ele.productName}`}
              </TableCell>
              <TableCell align="right" className={classes.TableCellFromData}>
                {ele.quantity.toLocaleString("pt-BR")}
              </TableCell>
              <TableCell align="right" className={classes.TableCellFromData}>
                {formatCurrency4DecimalsPlace(ele.price)}
              </TableCell>
              <TableCell align="right" className={classes.TableCellFromData}>
                {formatCurrency(ele.totalPrice)}
              </TableCell>
              <TableCell align="center" className={classes.TableCellFromData}>
                {getPaymentType(ele.payCond)}
              </TableCell>
              <TableCell align="center" className={classes.TableCellFromData}>
                {ele.freightType}
              </TableCell>
              <TableCell align="right" className={classes.TableCellFromData}>
                <StatusTag
                  text={getFinancialStatusPTBR(ele.statusAtem)}
                  type={getFinancialStatus(ele.statusAtem)}
                />
              </TableCell>
              <TableCell align="center" className={classes.TableCellFromData}>
                <RowDetailMenu
                  rowId={ele.numberOrder}
                  canShowPix={ele.payCond === 0}
                  onSelect={(rowId, type) => select(rowId, type)}
                  canDelete={Boolean(ele.allowedToCancel)}
                  onDelete={() => {
                    setOrderToCancel(ele);
                    setOpenModal(true);
                  }}
                />
              </TableCell>

              <TableCell align="center" className={classes.TableCellFromData}>
                {ele.creatorName ? (
                  <Tooltip title={ele.creatorEmail || ""}>
                    <span style={{ whiteSpace: "nowrap" }}>
                      {ele.creatorName}
                    </span>
                  </Tooltip>
                ) : (
                  <span style={{ whiteSpace: "nowrap" }}>
                    {getCreatorDisplayName(undefined, ele.creatorEmail)}
                  </span>
                )}
              </TableCell>

              {featureFlagDeliveryDate && (
                <TableCell
                  align="center"
                  className={classes.TableCellFromData}
                  colSpan={2}
                >
                  <Tooltip
                    title={
                      isBlockCalendarDelivery(ele.freightType, ele.statusAtem)
                        ? "Não é possível alterar data de agendamento para pedidos faturados"
                        : "Alterar data de entrega"
                    }
                    placement="left"
                  >
                    <span>
                      <IconButton
                        color="primary"
                        disabled={isBlockCalendarDelivery(
                          ele.freightType,
                          ele.statusAtem
                        )}
                        onClick={() => {
                          if (
                            !isBlockCalendarDelivery(
                              ele.freightType,
                              ele.statusAtem
                            )
                          ) {
                            handleOpenDeliveryCalendar();
                            setFreightTypeByLine(ele.freightType);
                            setNumberOrderByLine(ele.numberOrder);
                            setDeliveryDate(ele.deliveryDate);
                          }
                        }}
                      >
                        {isBlockCalendarDelivery(
                          ele.freightType,
                          ele.statusAtem
                        ) ? (
                          <CalendarChangeDeliveryDateDisabledIcon />
                        ) : (
                          <CalendarChangeDeliveryDateIcon />
                        )}
                      </IconButton>
                    </span>
                  </Tooltip>
                </TableCell>
              )}
            </>
          )}
        </TableRow>

        {isOpen(ele.numberOrder, "orders") && (
          <TableRow>
            <TableCell colSpan={14} style={{ padding: 0, margin: 0 }}>
              <Collapse in={true} timeout="auto" unmountOnExit>
                <DetailsOrdersStatus
                  tipoFrete={ele.freightType}
                  placa={ele.vehiclePlate}
                  status={ele.statusPortalCliente as statusType}
                  latitude={ele.latitude || 0}
                  longitude={ele.longitude || 0}
                  orderNumber={ele.numberOrder}
                  productName={ele.productName}
                  productID={ele.productID}
                  quantity={ele.quantity}
                  companyName={ele.companyName}
                />
              </Collapse>
            </TableCell>
          </TableRow>
        )}

        {isOpen(ele.numberOrder, "pix") && (
          <TableRow>
            <TableCell colSpan={14} style={{ padding: 0, margin: 0 }}>
              <Collapse in={true} timeout="auto" unmountOnExit>
                <PixPaymentPanel
                  razaoSocial={ele.companyName}
                  produto={ele.productName}
                  valorTotal={ele.totalPrice}
                  payCond={ele.payCond}
                  payloads={payloads}
                  loading={loading}
                />
              </Collapse>
            </TableCell>
          </TableRow>
        )}
      </>
    </Fade>
  );
};

export default TableRowData;
